import LabelChecklist from './LabelChecklist'

export default function CardChecklist(props) {
    const handleHeader = (fields) => {
        if(fields[0]) {
            const headerData = fields[0].items
            const hasChoice = headerData.filter(x => x.type == 'choice')

            return (
                <thead>
                    <tr>
                        {headerData.map((head) => (
                            <th className='border' rowSpan={hasChoice.length && head.type != 'choice' ? 2 : 1} colSpan={head.type == 'choice' ? head.values.length : 1}>{head.order == 1 ? 'Item' : head.label}</th>
                        ))}
                        
                    </tr>
                    {hasChoice.length && (
                        <tr>
                            {hasChoice.map((choice) => (
                                <>
                                    {choice.values.map((x) => (
                                        <th className='border'>{x}</th>
                                    ))}
                                </>
                            ))}
                        </tr>
                    )}
                </thead>

            )
        } else {
            return null
        }
    }

    const handleBody = (row) => {

        return (
            <tr>
                {row.map((item, index) => {
                    if(item.type == 'choice') {
                        return (
                            <>
                                {item.values.map((val, i) => (
                                    <td className='border' key={index}>{item.value ? val[i] : ''}</td>
                                ))}
                            </>
                        )
                    } else {
                        return (
                            <td className='border' key={index}>{index == 0 ? item.label : item.value}</td>
                        )
                    }
                })}
            </tr>
        )
    }
    
    return(
        <>
            <LabelChecklist label={props.title}/>
            {props.groups.map((group) => (
                <>
                    {group.title && (<h6 className="text-primary mt-4">{group.title}</h6>)}
                    <table className='table mb-2'>
                        {handleHeader(group.fields)}
                        <tbody className='table-border-bottom-0'>
                            {group.fields.map((field) => (
                                <>
                                    {handleBody(field.items)}
                                </>
                            ))}
                        </tbody>
                    </table>
                </>
            ))}
        </>
    )
}